import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WaitingIndicatorComponent } from './lib/waiting-indicator/waiting-indicator.component';
import { DialogComponent } from './lib/dialog/dialog.component';
import { ButtonComponent } from './lib/button/button.component';
import { SignpostsComponent } from './lib/signposts/signposts.component';
import { ResizeDirective } from './lib/directives/resize.directive';
import { ClrLoading } from './lib/popover/utils/loading/loading';
import { ScrollViewerComponent } from './lib/scroll-viewer/scroll-viewer.component';
import { PullToRefreshComponent } from './lib/pull-to-refresh/pull-to-refresh.component';
import { DatePanelComponent } from './lib/date-panel/date-panel.component';
import { DropdownComponent } from './lib/dropdown/dropdown.component';
import { TranslatePipe } from './lib/pipes/translate.pipe';
import { SearchInputComponent } from './lib/search-input/search-input.component';
import { DropdownItemComponent } from './lib/dropdown-item/dropdown-item.component';
import { ClrDropdownModule } from './lib/popover/dropdown/dropdown.module';
import { ClrConditionalModule } from './lib/popover/utils/conditional/conditional.module';
import { ClrCommonPopoverModule } from './lib/popover/common/popover.module';

@NgModule({
  declarations: [WaitingIndicatorComponent, DialogComponent, ButtonComponent, SignpostsComponent, ResizeDirective, ClrLoading, ScrollViewerComponent, PullToRefreshComponent, DatePanelComponent, DropdownComponent, TranslatePipe, SearchInputComponent, DropdownItemComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, ClrDropdownModule, ClrConditionalModule, ClrCommonPopoverModule],
  exports: [WaitingIndicatorComponent, DialogComponent, SignpostsComponent, DatePanelComponent],
})
export class LocalCommonUIModule {}
